// Single source of truth for the school "phase of education" options (slug -> label).
// Mirrors the API's App\Modules\Challenges\Enums\EducationPhase. Add new phases here.
// Declaration order is the display order (by prevalence, not alphabetical) and is
// preserved by JS for non-integer string keys, so a select can v-for over this directly.
//
// Kept identical in challenge-portal and admin-portal: copy any change to both.
export default {
  primary: 'Primary',
  secondary: 'Secondary',
  infant: 'Infant',
  junior: 'Junior',
  middle_school: 'Middle School',
  all_through: 'All through',
};
